export default __webpack_public_path__ + "static/media/tu-dublin-logo.5517df73.svg";